import React, { useState } from 'react'
import { RaceDTO } from '../../interfaces/RaceDTO'
import { ShootingsDTO } from '../../interfaces/ShootingsDTO';
import ShootingRow from './ShootingRow';
import './shootingstyle.css'
import { ShootingLiveDTO } from '../../interfaces/ShootingLiveDTO';

interface Props{
    race: RaceDTO;
}

const Shootings = ({race}:Props) => {

    const [shootView,setShootView] = useState<(ShootingLiveDTO | null) []>(race.ShootingRange)
    return (
    <div className='shooting-view'>
        {shootView.map((shoot,ind) =>(
            ind == 0 ? (<></>) :
            <ShootingRow key={ind + 1} lane={ind + 0} shooter={shoot} race={race} />
        ))}
    </div>
  )
}

export default Shootings